import React from 'react'
import Header from '../Header/Header'

export default function ItConsulting() {
  return (
   <>
    <Header isActive={"Services"}/>
    <div id="content" class="site-content">
        <div className="page-header dtable text-center" style={{ backgroundImage: 'url(resources/images/banner-.jpg)' }}>
            <div className="dcell">
                <div className="container">
                    <h1 className="page-title">IT Consulting</h1>
                </div>
            </div>
            </div>
            <section className="p-b0">
   <div className="container">
      <div className="flex-row">
         <div className="services-left-1">
            <img src="resources/images/image2-home4.png" alt="" />
         </div>
         <div className="services-right-1 align-self-center">
            <div className="ot-heading">
               <h6><span>IT Consulting</span></h6>
               <h2 className="main-heading">Enhance Your Expertise with Humanix Technologies</h2>
            </div>
            <p className="m-b50">At Humanix Technologies, we offer IT consulting services designed to elevate your software architecture, craft a technology-driven digital strategy, and optimize your software portfolio. Our expert software engineers will guide you through your digital transformation journey with precision, from strategic planning to seamless execution.</p>
            <div className="row">
               <div className="col-md-4 col-sm-6 col-xs-6 xs-text-center sm-m-b40">
                  <div className="ot-counter s3">
                     <div>
                        <span className="num" data-to="100" data-time="2000">0</span>
                        <span>+</span>
                     </div>
                     <h6>Active Developers</h6>
                  </div>
               </div>
               <div className="col-md-4 col-sm-6 col-xs-6 xs-text-center sm-m-b40 xs-m-b40">
                  <div className="ot-counter s3">
                     <div>
                        <span className="num" data-to="30" data-time="2000">0</span>
                        <span>+</span>
                     </div>
                     <h6>Satisfied Clients</h6>
                  </div>
               </div>
               <div className="col-md-4 col-sm-6 col-xs-6 xs-text-center sm-m-b40">
                  <div className="ot-counter s3">
                     <div>
                        <span className="num" data-to="50" data-time="2000">0</span>
                        <span>+</span>
                     </div>
                     <h6>Innovative Solutions Delivered</h6>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</section>

<section className="p-t110 p-b50">
   <div className="container">
      <div className="row">
         <h1>What You Will Gain</h1>
         <div className="col-md-6 col-sm-12 col-xs-12 sm-m-b40">
            <div className="service-box s-box m-b30">
               <div className="overlay"></div>
               <span className="big-number">01</span> 
               <div className="number-box">01</div>
               <div className="content-box">
                  <h5>Skilled Developers On-Demand</h5>
                  <p>Access a pool of highly skilled developers proficient in cutting-edge technologies to meet your business requirements.</p>
               </div>
            </div>
            <div className="service-box s-box">
               <div className="overlay"></div>
               <span className="big-number">02</span> 
               <div className="number-box">02</div>
               <div className="content-box">
                  <h5>Tailored Development Solutions</h5>
                  <p>Get developers with expertise in creating custom applications, scalable software, and business-driven IT solutions.</p>
               </div>
            </div>
         </div>
         <div className="col-md-6 col-sm-12 col-xs-12">
            <div className="service-box s-box m-b30">
               <div className="overlay"></div>
               <span className="big-number">03</span> 
               <div className="number-box">03</div>
               <div className="content-box">
                  <h5>Seamless Team Integration</h5>
                  <p>Hire developers who can integrate seamlessly with your in-house teams, ensuring smooth collaboration and productivity.</p>
               </div>
            </div>
            <div className="service-box s-box">
               <div className="overlay"></div>
               <span className="big-number">04</span> 
               <div className="number-box">04</div>
               <div className="content-box">
                  <h5>Scalable Workforce</h5>
                  <p>Quickly scale your development team to adapt to project needs, ensuring timely delivery and flexibility for your business.</p>
               </div>
            </div>
         </div>
      </div>
   </div>
</section>
{/* 
<section className="p-t110 p-b50">
   <div className="container">
      <div className="row">
         <h1>Key offerings of the program</h1>
         <div className="col-md-6 col-sm-12 col-xs-12 sm-m-b40">
            <div className="service-box s-box m-b30">
               <div className="overlay"></div>
               <span className="big-number">01</span> 
               <div className="number-box">01</div>
               <div className="content-box">
                  <h5>Career Mentorship</h5>
                  <p>Personalised career mentoring to help you prepare and build your profile</p>
               </div>
            </div>
            <div className="service-box s-box">
               <div className="overlay"></div>
               <span className="big-number">02</span> 
               <div className="number-box">02</div>
               <div className="content-box">
                  <h5>Doubt Solving Sessions</h5>
                  <p>Advance doubt resolution sessions by expert teaching assistants</p>
               </div>
            </div>
         </div>
         <div className="col-md-6 col-sm-12 col-xs-12">
            <div className="service-box s-box m-b30">
               <div className="overlay"></div>
               <span className="big-number">03</span> 
               <div className="number-box">03</div>
               <div className="content-box">
                  <h5>Mock Interviews</h5>
                  <p>Mock interviews to help you prepare for your job interviews</p>
               </div>
            </div>
            <div className="service-box s-box">
               <div className="overlay"></div>
               <span className="big-number">04</span> 
               <div className="number-box">04</div>
               <div className="content-box">
                  <h5>Capstone Projects</h5>
                  <p>Industry-relevant projects to build your portfolio and get you job-ready</p>
                  <a href="portfolio-grid.html" className="octf-btn octf-btn-icon octf-btn-third">See More <i className="flaticon-right-arrow-1"></i></a>
               </div>
            </div>
         </div>
      </div>
   </div>
</section>

<section className="p-t100 p-b50">
   <div className="container">
      <div className="row">
         <h1>Curriculum</h1>
         <div className="col-md-6 col-xs-12 sm-m-b40">
            <div className="ot-accordions">
               <div className="acc-item current">
                  <span className="acc-toggle">Level -1<i className="down flaticon-arrow-pointing-to-down"></i><i className="up flaticon-arrow-pointing-to-up"></i></span>
                  <div className="acc-content active" style={{ display: 'block' }}>
                     <h6>Programming Fundamentals</h6>
                     <div className="row">
                        <div className="col-xs-4">6 Weeks</div>
                        <div className="col-xs-4">1 Guest Lecture</div>
                        <div className="col-xs-4">2 Contests</div>
                     </div>
                     This module will help beginners to get familiar with programming
                  </div>
               </div>
               <div className="acc-item">
                  <span className="acc-toggle">Level -2 <i className="down flaticon-arrow-pointing-to-down"></i><i className="up flaticon-arrow-pointing-to-up"></i></span>
                  <div className="acc-content">
                     <h6>Building an E-Commerce Website</h6>
                     <div className="row">
                        <div className="col-xs-6">6 Weeks</div>
                        <div className="col-xs-6">1 Guest Lecture</div>
                     </div>
                     <p>Understand the core fundamentals of site building from industry experts and build an E-commerce website. Learning is meaningful when you can apply the concepts and solve real-world problems. We will explore this possibility in this module.</p>
                  </div>
               </div>
               <div className="acc-item">
                  <span className="acc-toggle">Level -3<i className="down flaticon-arrow-pointing-to-down"></i><i className="up flaticon-arrow-pointing-to-up"></i></span>
                  <div className="acc-content">
                     <h6>Data Structures and Algorithms</h6>
                     <div className="row">
                        <div className="col-xs-6">6 Weeks</div>
                        <div className="col-xs-6">1 Guest Lecture</div>
                     </div>
                     <p>Now that we have a fair idea about HTML, CSS, and React, let's enhance our problem-solving skills further by learning the intermediate and advanced concepts of Data Structures and Algorithms. In this module, we will extensively focus on problem-solving.</p>
                  </div>
               </div>
            </div>
         </div>
         <div className="col-md-6 col-xs-12">
            <div className="ot-accordions accordions-gradient">
               <div className="acc-item current">
                  <span className="acc-toggle">Level -4<i className="down flaticon-arrow-pointing-to-down"></i><i className="up flaticon-arrow-pointing-to-up"></i></span>
                  <div className="acc-content active" style={{ display: 'block' }}>
                     <h6>Building a CRM App</h6>
                     <div className="row">
                        <div className="col-xs-6">5 Weeks</div>
                        <div className="col-xs-6">1 Contest</div>
                     </div>
                     <p>Build the frontend to run a CRM app that will help you manage all your business leads at one place and provide a complete picture of all customer interactions...</p>
                  </div>
               </div>
               <div className="acc-item">
                  <span className="acc-toggle">Level -5<i className="down flaticon-arrow-pointing-to-down"></i><i className="up flaticon-arrow-pointing-to-up"></i></span>
                  <div className="acc-content">
                     <h6>Building a Movie Booking App</h6>
                     <div className="row">
                        <div className="col-xs-6">4 Weeks</div>
                        <div className="col-xs-6">1 Contest</div>
                     </div>
                     <p>Build a website in which users can book a movie, a match, or any event of their choice at a location and price suitable for them.</p>
                  </div>
               </div>
               <div className="acc-item">
                  <span className="acc-toggle">Level -6<i className="down flaticon-arrow-pointing-to-down"></i><i className="up flaticon-arrow-pointing-to-up"></i></span>
                  <div className="acc-content">
                     <h6>Interview Practice</h6>
                     <div className="row">
                        <div className="col-xs-6">4 Weeks</div>
                        <div className="col-xs-6">1 Contest</div>
                     </div>
                     <p>Solve sample test questions and get ready to ace the interviews.</p>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</section>

<section className="p-t120 p-b50 bg-pricing">
   <div className="container">
      <div className="ot-heading text-center">
         <h2 className="main-heading">Pricing Details</h2>
      </div>
      <div className="row">
         <div className="col-md-4 sm-p-b60">
         </div>
         <div className="col-md-4 sm-p-b60">
            <div className="ot-pricing-table bg-shape s2">
               <span className="title-table">10% Discount</span>
               <div className="inner-table sm-p-t60">
                  <img src="resources/images/price2-1.png" alt="Economy" />
                  <h6><s><sup>₹</sup> 55000</s></h6>
                  <h2><sup>₹</sup> 49500</h2>
                  <div className="details">
                     <ul>
                        <li>Course Duration 6 Months</li>
                        <li>40L Highest salary offered</li>
                        <li>8.4L Average CTC offered</li>
                        <li>9 Days Placement time</li>
                        <li>Upto 350% Salary hike</li>
                     </ul>
                  </div>
               </div>
               <a href="contact.html" className="octf-btn octf-btn-icon octf-btn-third">ENROLL NOW <i className="flaticon-right-arrow-1"></i></a>
            </div>
         </div>
         <div className="col-md-4">
         </div>
      </div>
   </div>
</section> */}

<section className="container">
   <div className="p-t120">
      <div className="row flex-row align-items-end">
         <div className="col-lg-6 col-md-12 col-xs-12 xs-m-b40">
            <div className="ot-heading">
               <h2 className="main-heading">Here to Help Your Every Business Need</h2>
            </div>
            <div className="ot-accordions">
               <div className="acc-item current">
                  <div className="acc-content active" style={{ display: 'block' }}>We specialize in delivering IT solutions, allowing you to concentrate on growing your business.
Let us handle the technical challenges while you focus on what matters most.
Explore how our expertise can streamline your operations and drive success.
Partner with us to unlock the full potential of your business through tailored IT services.
We're here to provide seamless support, ensuring your business thrives.
Discover what we can achieve together—start today!.</div>
               </div>
            </div>
         </div>
         <div className="col-lg-6 col-md-12 col-xs-12 text-center">
            <img src="resources/images/img.png" alt="seo" />
         </div>
      </div>
   </div>
</section>
{/* 
<section className="p-b120">
   <div className="container">
      <div className="row">
         <div className="col-md-12">
            <div className="partners">
               <div className="owl-carousel home-client-carousel">
                  <div className="partners-slide">
                     <a href="#" className="client-logo">
                        <figure className="partners-slide-inner">
                           <img className="partners-slide-image" src="resources/images/brands/zoomcar-4.webp" alt="" />
                        </figure>
                     </a>
                  </div>
                  <div className="partners-slide">
                     <a href="#" className="client-logo">
                        <figure className="partners-slide-inner">
                           <img className="partners-slide-image" src="resources/images/brands/zoomcar-10.webp" alt="" />
                        </figure>
                     </a>
                  </div>
                  <div className="partners-slide">
                     <a href="#" className="client-logo">
                        <figure className="partners-slide-inner">
                           <img className="partners-slide-image" src="resources/images/brands/zoomcar-8.webp" alt="" />
                        </figure>
                     </a>
                  </div>
                  <div className="partners-slide">
                     <a href="#" className="client-logo">
                        <figure className="partners-slide-inner">
                           <img className="partners-slide-image" src="resources/images/brands/zoomcar-6.webp" alt="" />
                        </figure>
                     </a>
                  </div>
                  <div className="partners-slide">
                     <a href="#" className="client-logo">
                        <figure className="partners-slide-inner">
                           <img className="partners-slide-image" src="resources/images/brands/zoomcar-17.webp" alt="" />
                        </figure>
                     </a>
                  </div>
                  <div className="partners-slide">
                     <a href="#" className="client-logo">
                        <figure className="partners-slide-inner">
                           <img className="partners-slide-image" src="resources/images/brands/cred.webp" alt="" />
                        </figure>
                     </a>
                  </div>
                  <div className="partners-slide">
                     <a href="#" className="client-logo">
                        <figure className="partners-slide-inner">
                           <img className="partners-slide-image" src="resources/images/brands/delhiberry.webp" alt="" />
                        </figure>
                     </a>
                  </div>
                  <div className="partners-slide">
                     <a href="#" className="client-logo">
                        <figure className="partners-slide-inner">
                           <img className="partners-slide-image" src="resources/images/brands/meeso.webp" alt="" />
                        </figure>
                     </a>
                  </div>
                  <div className="partners-slide">
                     <a href="#" className="client-logo">
                        <figure className="partners-slide-inner">
                           <img className="partners-slide-image" src="resources/images/brands/paytm.webp" alt="" />
                        </figure>
                     </a>
                  </div>
                  <div className="partners-slide">
                     <a href="#" className="client-logo">
                        <figure className="partners-slide-inner">
                           <img className="partners-slide-image" src="resources/images/brands/upgrad.webp" alt="" />
                        </figure>
                     </a>
                  </div>
                  <div className="partners-slide">
                     <a href="#" className="client-logo">
                        <figure className="partners-slide-inner">
                           <img className="partners-slide-image" src="resources/images/brands/rakuten.png" alt="" />
                        </figure>
                     </a>
                  </div>
                  <div className="partners-slide">
                     <a href="#" className="client-logo">
                        <figure className="partners-slide-inner">
                           <img className="partners-slide-image" src="resources/images/brands/delhiberry.webp" alt="" />
                        </figure>
                     </a>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</section> */}

    </div>
   </>
  )
}
